import Swal from "sweetalert2";

// 自定义Hook用于显示操作反馈的SweetAlert
const useFeedbackDialog = () => {
  // 显示成功反馈
  const showSuccess = (title = "Success!", message = "Operation completed successfully.") => {
    Swal.fire({
      title,
      text: message,
      icon: "success",
      confirmButtonColor: "#10B981", // 绿色主题色
      confirmButtonText: "OK",
    });
  };

  // 显示错误反馈
  const showError = (title = "Error!", message = "Something went wrong.") => {
    Swal.fire({
      title,
      text: message,
      icon: "error",
      confirmButtonColor: "#EF4444", // 红色主题色
      confirmButtonText: "Got it",
    });
  };

  // 显示信息反馈
  const showInfo = (title = "Information", message = "Here is some useful info.") => {
    Swal.fire({
      title,
      text: message,
      icon: "info",
      confirmButtonColor: "#3B82F6", // 蓝色主题色
      confirmButtonText: "Understood",
    });
  };

  // 显示警告反馈
  const showWarning = (title = "Warning!", message = "Please check the details.") => {
    Swal.fire({
      title,
      text: message,
      icon: "warning",
      confirmButtonColor: "#F59E0B", // 黄色主题色
      confirmButtonText: "Got it",
    });
  };

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };
};

export default useFeedbackDialog;
